import { render, staticRenderFns } from "./SupplierEventProductList.vue?vue&type=template&id=2eefad2c&scoped=true&"
import script from "./SupplierEventProductList.vue?vue&type=script&lang=ts&"
export * from "./SupplierEventProductList.vue?vue&type=script&lang=ts&"
import style0 from "./SupplierEventProductList.vue?vue&type=style&index=0&id=2eefad2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eefad2c",
  null
  
)

export default component.exports